module.exports = __webpack_public_path__ + "img/denglubeijing.5bf5e4b9.png";